import axios from 'axios'

import { ENV } from '@/common/constants/env'
import { SignInResponse } from '@/modules/login/hooks/useSignIn'

type ApplicationTokenParams = {
  username: string
  password: string
}

export async function getApplicationToken({
  username,
  password,
}: ApplicationTokenParams) {
  const axiosWithoutInterceptors = axios.create({
    baseURL: ENV.VITE_BACKEND_URL,
  })

  const response = await axiosWithoutInterceptors.post<SignInResponse>(
    '/oauth/token',
    {
      username,
      password,
    },
  )
  return response.data.access_token
}
